<template>
    <rect width="24" height="24" v-bind:fill="getSponsorPattern(p)"
          v-bind:data-stop="s.title"
          v-bind:transform="pipeRectTranslation(pIdx, p.tone_ref.list[0].index)"
    ></rect>
</template>
<script>
export default {
  name: 'pipe-rect',
  props: {
    p: {},
    pIdx: {},
    s: {}
  },
  methods: {
    getSponsorPattern (pipe) {
      let fill = ''
      let priceString = pipe.price_ref.list[0].amount.toString()

      if (pipe.sponsor_ref.list.length > 0) {
        fill = 'url(#sponsor-' + priceString + ')'
      } else {
        switch (priceString) {
          case '1500':
            fill = '#768e53'
            break
          case '1000':
            fill = '#bbd0a1'
            break
          case '500':
            fill = '#3d668f'
            break
          case '250':
            fill = '#6a98b9'
            break
          case '100':
            fill = '#aac4d4'
            break
          case '50':
            fill = '#f5c177'
            break
        }
      }

      return fill
    },
    pipeRectTranslation (pipeIndex, toneIndex) {
      let x = 0
      let translate = ''
      if (pipeIndex !== toneIndex) {
        x = (toneIndex) * 25
      } else {
        x = (pipeIndex + 1) * 25 - 25
      }
      translate = 'translate(' + x + ' 0)'
      return translate
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PipeRect.vue